// The funnel saves the chosen brand to the account brain fire-and-forget so
// step transitions never block on it. Story creation, however, copies the
// account brain — so the completion path briefly waits (bounded) for any
// pending save to land, closing the copy-before-save race.

let pending: Promise<unknown> | null = null;

export const trackBrandSave = (save: Promise<unknown>) => {
  const tracked = save
    .catch(() => undefined)
    .finally(() => {
      if (pending === tracked) pending = null;
    });
  pending = tracked;
};

export const waitForBrandSave = async (timeoutMs = 4000): Promise<void> => {
  if (!pending) return;
  await Promise.race([
    pending,
    new Promise<void>((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
};
